import styled from 'styled-components';

export const EmbedYoutubeWrapper = styled.div`
.responsive-iframe {
    width: 100%; 
    height: auto;         
    aspect-ratio: 16 / 9;  
    border: none;
  }
`;
